import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gettLabelpage, handleOut, handleAddUser, getLabelInfo } from "@/api/managementCenter/labelManage";
import chargePerson from "@/components/management/reportManage/chargePerson.vue";
import * as serve from "@/api/importAndExport/excelApi";
import importExcel from "@/components/dialog/deptManage/importExcel.vue";
export default {
  name: "memberList",
  components: {
    chargePerson: chargePerson,
    importExcel: importExcel
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        name: ""
      },
      total: 0,
      labelId: "",
      labelName: "",
      selectionChecked: [],
      personData: {
        userData: [],
        state: false,
        disabled: false,
        data: null
      },
      uplodData: {
        state: false,
        type: ""
      }
    };
  },
  computed: {},
  mounted: function mounted() {},
  methods: {
    changeFun: function changeFun(val) {
      this.selectionChecked = val;
    },
    loadListFn: function loadListFn(item) {
      this.labelId = item.labelId;
      this.labelName = item.labelName;

      if (this.labelId) {
        this.getListFn();
      }
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this = this;

      this.list = [];
      this.total = 0;
      this.loading = true;
      gettLabelpage(_objectSpread(_objectSpread({}, this.paramSearch), {}, {
        labelId: this.labelId
      })).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.selectionChecked = [];
          _this.list = data.data.records || [];
          _this.total = data.data.total;
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    openDetail: function openDetail() {
      this.$emit("openDetail", this.labelId);
    },
    batchDelHandle: function batchDelHandle() {
      var _this2 = this;

      if (this.selectionChecked.length == 0) {
        this.$message.warning("请勾选要移出的人员");
        return;
      }

      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var ids = _this2.selectionChecked.map(function (i) {
          return i.userId;
        }).toString();

        _this2.deleteHttp(ids);
      }).catch(function () {
        _this2.$message.info("已取消删除");
      });
    },
    deleteHttp: function deleteHttp(ids) {
      var _this3 = this;

      this.loading = true; // 删除接口

      var params = {
        labelId: this.labelId || "",
        labelUserIds: ids
      };
      handleOut(params).then(function (_ref2) {
        var data = _ref2.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success("移出成功!");

          _this3.getListFn();
        } else {
          _this3.$message.warning(data.msg || "移出失败！");
        }
      }).catch(function () {
        _this3.loading = false;

        _this3.$message.error("删除异常!");
      });
    },
    //显示人员选择
    addUser: function addUser() {
      var _this4 = this;

      this.getLabelInfoFn(this.labelId).then(function () {
        _this4.$refs.personModal.loadData();

        _this4.personData.state = true;
      });
    },
    //选择人员
    closePerson: function closePerson(value) {
      if (!value.mans) {
        this.personData.state = false;
        return;
      }

      var mans = value.mans || [];
      var userList = mans.map(function (item) {
        return {
          userId: item.userId
        };
      });
      this.handleAddUserFn(userList);
    },
    getLabelInfoFn: function getLabelInfoFn(id) {
      var _this5 = this;

      return new Promise(function (resolve) {
        _this5.loading = true;
        getLabelInfo(id).then(function (_ref3) {
          var data = _ref3.data;
          _this5.loading = false;

          if (data.code == 0) {
            _this5.personData.data = (data.data.userList || []).map(function (i) {
              return {
                userId: i.userId,
                name: i.username
              };
            });
            _this5.personData.userData = (data.data.userList || []).map(function (i) {
              return i.userId;
            });
            resolve();
          } else {
            _this5.$message.warning(data.msg || "获取标签信息失败！");
          }
        }).catch(function (err) {
          _this5.loading = false;
        });
      });
    },
    handleAddUserFn: function handleAddUserFn(userList) {
      var _this6 = this;

      this.$refs.personModal.$refs.selectUser.sureBtnDisabled = true;
      var data = {
        labelId: this.labelId,
        userList: userList
      };
      this.loading = true;
      handleAddUser(data).then(function (_ref4) {
        var data = _ref4.data;
        _this6.loading = false;
        _this6.$refs.personModal.$refs.selectUser.sureBtnDisabled = false;

        if (data.code == 0) {
          _this6.$message.success("添加成员成功!");

          _this6.personData.state = false;
          _this6.paramSearch.size = 10;
          _this6.paramSearch.current = 1;

          _this6.getListFn();
        } else {
          _this6.$message.warning(data.msg || "添加成员失败!");
        }
      }).catch(function (err) {
        _this6.$refs.personModal.$refs.selectUser.sureBtnDisabled = false;
        _this6.loading = false;
      });
    },
    handleCommand: function handleCommand(commandType) {
      switch (commandType) {
        case "importExcel":
          this.importExcelFn();
          break;

        case "exportExcel":
          this.downloadFn(serve.excelExport("label"));
          break;

        case "downloadTemplate":
          this.downloadFn(serve.downloadTemplate("label"));
          break;
      }
    },
    importExcelFn: function importExcelFn() {
      this.uplodData.state = true;
      this.uplodData.type = "label";
    },
    closeUplod: function closeUplod(val) {
      this.uplodData.state = val;
    },
    successCallBack: function successCallBack() {
      this.$emit("saveSuccess");
    },
    downloadFn: function downloadFn(url) {
      var _this7 = this;

      this.$DownLoad(url, null, function (res) {
        if (res.status == 200) {} else {
          _this7.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this7.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    }
  },
  watch: {},
  filters: {
    userDeptNameFilter: function userDeptNameFilter(value) {
      if (value.substr(value.length - 1, 1) == "/") {
        value = value.substring(0, value.length - 1);
      }

      return value;
    }
  }
};